import { ORDER_STATUS } from '@/api/types/order'

/**
 * Заполненность полосы в карточке. Кодов у бэкенда девять, полоса одна —
 * раскладываем их по долям пути от оформления до выдачи.
 */
const PROGRESS: Record<number, number> = {
  [ORDER_STATUS.forming]: 0.05,
  [ORDER_STATUS.new]: 0.1,
  [ORDER_STATUS.payed]: 0.15,
  [ORDER_STATUS.accepted]: 0.3,
  [ORDER_STATUS.searchDriver]: 0.4,
  [ORDER_STATUS.cooking]: 0.55,
  [ORDER_STATUS.ready]: 0.75,
  [ORDER_STATUS.delivery]: 0.9,
  [ORDER_STATUS.delivered]: 1,
  [ORDER_STATUS.canceled]: 1,
}

/** Незнакомый код — заказ где-то посередине пути, полосу рисуем наполовину. */
const UNKNOWN_PROGRESS = 0.5

/** Заказ в работе, пока бэкенд не сказал «доставлен» или «отменён». */
export function isActiveOrder(statusCode: number): boolean {
  return statusCode < ORDER_STATUS.delivered
}

export function statusProgress(statusCode: number): number {
  return PROGRESS[statusCode] ?? (isActiveOrder(statusCode) ? UNKNOWN_PROGRESS : 1)
}

export function isCanceledOrder(statusCode: number): boolean {
  return statusCode === ORDER_STATUS.canceled
}

/**
 * Код статуса → шаг степпера. Кодов больше, чем шагов на экране, поэтому
 * несколько кодов сходятся в один шаг: клиенту всё равно, «принят» заказ
 * или «оплачен», — он видит «Принят».
 *
 * У самовывоза шагов три (принят → готовится → можно забирать), у доставки
 * пять, и «готов» там означает не выдачу, а ожидание курьера.
 */
const DELIVERY_STEP: Record<number, number> = {
  [ORDER_STATUS.forming]: 0,
  [ORDER_STATUS.new]: 0,
  [ORDER_STATUS.payed]: 0,
  [ORDER_STATUS.accepted]: 0,
  [ORDER_STATUS.cooking]: 1,
  [ORDER_STATUS.ready]: 1,
  [ORDER_STATUS.searchDriver]: 2,
  [ORDER_STATUS.delivery]: 3,
  [ORDER_STATUS.delivered]: 4,
}

const PICKUP_STEP: Record<number, number> = {
  [ORDER_STATUS.forming]: 0,
  [ORDER_STATUS.new]: 0,
  [ORDER_STATUS.payed]: 0,
  [ORDER_STATUS.accepted]: 0,
  [ORDER_STATUS.cooking]: 1,
  [ORDER_STATUS.ready]: 2,
  [ORDER_STATUS.delivered]: 2,
}

export function statusStep(statusCode: number, isPickup: boolean): number {
  const map = isPickup ? PICKUP_STEP : DELIVERY_STEP
  const last = isPickup ? 2 : 4
  return map[statusCode] ?? (isActiveOrder(statusCode) ? 0 : last)
}

/**
 * Номер заказа строкой. `/delivery/List` отдаёт его строкой, `/delivery/Get` —
 * числом, поэтому приводим в одном месте, а не по месту использования.
 */
export function orderNumber(order: { number: string | number; seqNumber?: string | null }): string {
  return String(order.number || order.seqNumber || '')
}
